// config/pricing.ts
// Centralized pricing constants for UI display
// NOTE: These are UI display values only. Do not change Stripe product IDs or environment variables.

/**
 * Re-export PLAN_PLUS from canonical location for backward compatibility.
 * New code should import from @/lib/plans instead.
 */
import { PLAN_PLUS } from '@/lib/plans';
export { PLAN_PLUS };

// Legacy exports for backward compatibility (deprecated - use PLAN_PLUS instead)
export const PRO_MONTHLY_PRICE = PLAN_PLUS.monthlyPrice;
export const PRO_YEARLY_PRICE = PLAN_PLUS.yearlyPrice;

export const PRO_MONTHLY_PRICE_DISPLAY = `$${PLAN_PLUS.monthlyPrice}/month`;
export const PRO_YEARLY_PRICE_DISPLAY = `$${PLAN_PLUS.yearlyPrice}/year`;

